import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import PostBackgroundContext from "../../../../context/PostBackgroundContext/PostBackgroundContext";
import {
  deletePostBackground,
  enableDisablePostBackground,
  getDetailsPostBackground,
} from "../../../../Apis/postBackgroundApi/PostBackgroundApi";
import Actions from "../../../../layouts/Actions";

const PostBackgroundDataTableContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setDialogs,
    setOrgId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(PostBackgroundContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get Post Background Details
   */
  const {
    mutate: categoryPostBackground,
    isLoading: isLoadingPostBackgroundDetails,
  } = useMutation((posterBackgroundMasterId) =>
    getDetailsPostBackground(posterBackgroundMasterId, setFormData, setDialogs)
  );

  const GetPostBackgroundDetails = (posterBackgroundMasterId) => {
    categoryPostBackground(posterBackgroundMasterId);
    setOrgId(posterBackgroundMasterId);
    setIsEdit(false);
  };

  /**
   * delete Post Background
   */
  const { mutate: postBackgroundDelete, isLoading: isLoadingDelete } =
    useMutation((posterBackgroundMasterId) =>
      deletePostBackground(posterBackgroundMasterId, refetch)
    );

  const DeletePostBackground = async (posterBackgroundMasterId) => {
    SweetConfirmation(postBackgroundDelete, posterBackgroundMasterId);
  };

  /**
   * enable / disable Post Background
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    enableDisablePostBackground(formData, refetch)
  );

  const handleCompanyStatusChange = (posterBackgroundMasterId, status) => {
    let formDate = {
      posterBackgroundMasterId: posterBackgroundMasterId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.posterBackgroundMasterId === posterBackgroundMasterId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 100,
      field: "image",
      headerName: "Image",
      renderCell: (params) => (
        // params.row.logo ? params.row.logo : "--"
        <div className="flex justify-content-center ">
          <img
            className="img-thumbnail"
            src={params.row.image}
            alt=""
            width={100}
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "thumbImage",
      headerName: "Thumb Image",
      renderCell: (params) => (
        // params.row.logo ? params.row.logo : "--"
        <div className="flex justify-content-center ">
          <img
            className="img-thumbnail"
            src={params.row.thumbImage}
            alt=""
            width={100}
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      renderCell: (params) => (params.row.name ? params.row.name : "--"),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "color",
      headerName: "Color",
      renderCell: (params) =>
        params.row.color ? (
          <div
            style={{
              height: "45px",
              width: "45px",
              background: `#${params.row.color.replace(/#/g, "")}`,
              borderRadius: "10px",
            }}
          ></div>
        ) : (
          "--"
        ),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleCompanyStatusChange(
                params.row.posterBackgroundMasterId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <Actions
            id={params.row.posterBackgroundMasterId}
            getDetails={GetPostBackgroundDetails}
            deleteDetails={DeletePostBackground}
          />
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingPostBackgroundDetails || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.posterBackgroundMasterId}
        addButton={true}
      />
    </Fragment>
  );
};

export default PostBackgroundDataTableContainer;
